/*==========================================================
INITIALIZE INCLUDE SCRIPT
==========================================================*/
var _gaTrackingCode = "";

function isSiteinICreateMode() {
    if (isFrontEndDev) {
        return "False".toLowerCase() == "true"
    } else {
        return iCreateObject.isSiteInICreateMode;
    }
}

//disable print on iCreate
function PrintScreen() {
    if (isSiteinICreateMode()) {
        showNAMessage()
    } else {
        window.print()
    }
}

function getCorpRoot() {
    return ""
}

function getCorpHome() {
    var e = "../";
    try {
        if (document.location.href.toLowerCase().indexOf("https://") == 0) {
            e = "https://" + e.substring(7)
        }
    } catch (t) {}
    return e
}

function getLang() {
    return "en"
}

function getAtozHttpHandlerUrl() {
    return "http://atoz.icreate.esolutionsgroup.ca/search/480"
}

// $("#nav").superfish({
//     cssArrows: false,
//     speed: "normal",
//     speedOut: "fast"
// });

//mediaelement-and-player.js init
if ($('video,audio').is('*') && $().mediaelementplayer) {
    $('video,audio').mediaelementplayer({
        // if the <video width> is not specified, this is the default
        defaultVideoWidth: 480,
        // if the <video height> is not specified, this is the default
        defaultVideoHeight: 270,
        // if set, overrides <video width>
        videoWidth: -1,
        // if set, overrides <video height>
        videoHeight: -1,
        // width of audio player
        audioWidth: 400,
        // height of audio player
        audioHeight: 30,
        // initial volume when the player starts
        startVolume: 0.8,
        // useful for <audio> player loops
        loop: false,
        // enables Flash and Silverlight to resize to content size
        enableAutosize: true,
        // the order of controls you want on the control bar (and other plugins below)
        features: ['playpause', 'progress', 'current', 'duration', 'tracks', 'volume', 'fullscreen'],
        // Hide controls when playing and mouse is not over the video
        alwaysShowControls: false,
        // force iPad's native controls
        iPadUseNativeControls: false,
        // force iPhone's native controls
        iPhoneUseNativeControls: false,
        // force Android's native controls
        AndroidUseNativeControls: false,
        // forces the hour marker (##:00:00)
        alwaysShowHours: false,
        // show framecount in timecode (##:00:00:00)
        showTimecodeFrameCount: false,
        // used when showTimecodeFrameCount is set to true
        framesPerSecond: 25,
        // turns keyboard support on and off for this instance
        enableKeyboard: true,
        // when this player starts, it will pause other players
        pauseOtherPlayers: true,
        // array of keyboard commands
        keyActions: []
    });
}
// Google Site Search
$(window).load(function() {
    setTimeout(function() {
        $('form.gsc-search-box').find('input.gsc-input').each(function() {
            $(this).attr("placeholder", 'What are you looking for?');
        });
        //change First option in google translate to say Translate instead of Default
        $('.translateContainer .goog-te-combo select option:nth-of-type(1)').text('Translate');
    }, 1);
});
